import { Directive, Input, OnInit, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NumberUtils } from '../utils';

@Directive({
	selector: '[smNumberInput]'
})
export class SmNumberInputDirective implements OnInit, OnDestroy {
	@Input('smNumberInput') configuration: string = 'integer';

	private _configurations: { [key: string]: ISmNumberInputOptions } = {
		'integer': { allowDecimal: false, decimalLimit: 0 },
		'decimal': { allowDecimal: true, decimalLimit: -1 },
		'price': { allowDecimal: true, decimalLimit: 2 },
		'decimal2': { allowDecimal: true, decimalLimit: 2 }
	};
	private _subs: Subscription[] = [];

	constructor(private _control: NgControl, private _e: ElementRef) { }

	ngOnInit(): void {
		this._updateValue(this._control.value);
		this._subs.push(this._control.valueChanges.subscribe(value => {
			this._updateValue(value);
		}));
	}

	ngOnDestroy() {
		this._subs.forEach(s => s && s.unsubscribe());
	}

	/// METHODS
	@HostListener('keyup', ['$event'])
	onKeypress(event: any) {
		let keyCode = 0;
		if (event.which == null) {
			keyCode = event.keyCode;
		}    // old IE
		else if (event.which != 0) {
			keyCode = event.which;
		}	  // All others
		const config = this._getCurrent();
		if (config.allowDecimal && (keyCode == 188 || keyCode == 190)) {
			return;
		}

		if (!this._isValid(event.target.value + event.key)) {
			event.preventDefault();
			return false;
		}
	}

	@HostListener('paste', ['$event'])
	onPaste(event: any) {
	}

	/// PRIVATE METHODS

	private _getCurrent() {
		let config = this._configurations[this.configuration];

		if (config == null) {
			throw `Configuration with key '${this.configuration}' wasn't found!`;
		}

		return config;
	}

	private _getDecimalLimit(): number {
		const config = this._getCurrent();
		if (config.allowDecimal) {
			return config.decimalLimit || 0;
		}

		return 0;
	}

	private _isValid(value: number): boolean {
		let raw = NumberUtils.toFixedNumber(value, this._getDecimalLimit());
		return value == raw;
	}

	private _updateValue(value: number) {
		if (value == null) {
			return;
		}

		let raw = NumberUtils.toFixedNumber(value, this._getDecimalLimit());
		let formatted = raw.toString();

		if (value != raw) {
			this._control.valueAccessor.writeValue(raw);
			this._control.viewToModelUpdate(raw);
		}
	}
}

export interface ISmNumberInputOptions {
	decimalLimit: number;
	allowDecimal: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/directives/sm-number-input.directive.ts